import React, { Component, Fragment } from "react";
import TopNavigation from "../../Components/Common/TopNavigation";
import Footer from "../../Components/Common/Footer";
import PaymentCancel from "../../Components/PaymentCancel/PaymentCancel";
import { Redirect } from "react-router";
import SessionHelper from "../../Helper/SessionHelper";

class PaymentCancelPage extends Component {
  constructor({ match }) {
    super();
    this.state = {
      trx: match.params.trx,
      RedirectWithoutLogin: false,
    };
  }

  componentDidMount() {
    window.scroll(0, 0);
    this.CheckLogin();
  }

  pageRedirectWithoutLogin = () => {
    if (this.state.RedirectWithoutLogin === true) {
      return <Redirect to="/" />;
    }
  };
  CheckLogin = () => {
    let Login = SessionHelper.getLogin();
    if (Login !== "YES") {
      this.setState({ RedirectWithoutLogin: true });
    }
  };

  render() {
    return (
      <Fragment>
        <TopNavigation />
        <div className="responsive-padding-top">
          <PaymentCancel />
        </div>
        <Footer />
        {this.pageRedirectWithoutLogin()}
      </Fragment>
    );
  }
}

export default PaymentCancelPage;
